import { IAppointmentDetails, IGroupedAppointment }
  from "../../services/appointment-list/appointment-list.interface";
import { ASSIGNED_BOOKING_TYPE } from "../../config/params";

/**
 * Groups consecutive appointments at the same
 * location into a single group.
 * @param {IAppointmentDetails[]} appointments - list
 * @return {IGroupedAppointment[]} grouped list
 */
const MAX_GROUP_SIZE = 3;

export const groupAppointments = (appointments: IAppointmentDetails[]): IGroupedAppointment[] => {
  if (!appointments || appointments.length === 0) return [];

  const sorted = [...appointments].sort((a, b) => a.start_at - b.start_at);
  const groups: IGroupedAppointment[] = [];

  let currentGroup: IAppointmentDetails[] = [sorted[0]];

  for (let i = 1; i < sorted.length; i++) {
    const prev = sorted[i - 1];
    const curr = sorted[i];

    const prevEndTime = prev.start_at + prev.duration;
    const sameLocation = prev.location.idLocation === curr.location.idLocation;
    const isConsecutive = curr.start_at === prevEndTime;
    const bothUrgent =
      prev.appointmentCreateType === ASSIGNED_BOOKING_TYPE.URGENT_BOOKING &&
      curr.appointmentCreateType === ASSIGNED_BOOKING_TYPE.URGENT_BOOKING;

    if (sameLocation && isConsecutive && bothUrgent && currentGroup.length < MAX_GROUP_SIZE) {
      currentGroup.push(curr);
    } else {
      groups.push(buildGroup(currentGroup));
      currentGroup = [curr];
    }
  }

  groups.push(buildGroup(currentGroup));

  return groups;
};

const buildGroup = (appointments: IAppointmentDetails[]): IGroupedAppointment => ({
  appointments,
  start_at: appointments[0].start_at,
  location: appointments[0].location,
});
